export default function ErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) {
  return (
    <div className="rounded-2xl bg-white p-8 ring-1 ring-ink-100">
      <h2 className="text-2xl font-semibold text-ink-800">
        Can&apos;t load the catalog right now
      </h2>
      <p className="mt-2 max-w-xl text-ink-500">
        We couldn&apos;t reach the catalog. Please try again in a minute.
      </p>
      <pre className="mt-4 max-w-xl overflow-auto rounded-xl bg-ink-50 p-3 text-xs text-ink-500">
        {message}
      </pre>
      <button type="button" className="btn-primary mt-4" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}
